@if (true || (workspaces && workspaces.length)) {
  <app-form-field-wrapper
    [label]="label"
    [name]="name"
    [colSize]="colSize"
    [formField]="formField">
    <p-multiSelect
      display="chip"
      emptyMessage="Keine Arbeitsbereiche vorhanden"
      (ngModelChange)="onChange($event)"
      [options]="workspaces"
      [(ngModel)]="selection"
      [filter]="workspaces.length > 10"
      [showToggleAll]="workspaces.length > 2"
      optionLabel="name"
      optionValue="_id"
      dataKey="_id">
      <ng-template pTemplate="header">
        @if (enableNewOption) {
          <p-button
            styleClass="w-auto"
            [text]="true"
            [rounded]="true"
            (onClick)="openWorkspaceForm()"
            icon="fas fa-plus"
            label="hinzufügen"></p-button>
        }
      </ng-template>
      <ng-template let-item pTemplate="item">
        <div class="flex align-items-center gap-2">
          @if (type) {
            <i [class]="workspaceTypeIconMap[type]"></i>
          } @else if (item.type) {
            <i
              [class]="workspaceTypeIconMap[asWorkspaceTypeKey(item.type)]"></i>
          }
          <div>{{ item.name }}</div>
        </div>
      </ng-template>
    </p-multiSelect>
  </app-form-field-wrapper>
} @else {
  <app-alert severity="info" header="Keine Arbeitsbereiche vorhanden">
    <p>
      Arbeitsbereiche können mit Rechten versehen werden, um den Zugriff auf
      Inhalte zu beschränken.
    </p>
    <p>
      <p-button
        styleClass="w-auto"
        label="Neuen Arbeitsbereich erstellen"
        [rounded]="true"
        [routerLink]="[
          '/data-backend',
          {
            outlets: {
              overlay: ['neu', { outlets: { panel: ['workspace', 'neu'] } }],
            },
          },
        ]"
        icon="fas fa-plus"
        class="w-auto"></p-button>
    </p>
  </app-alert>
}
